export enum ServiceStatus {
  None = 0,
  Active = 1,
  Cancelled = 2,
  Onboarding = 3,
  Suspended = 4,
  Migrated = 5
}

export interface ServiceStatusSet {
  m365Status: ServiceStatus;
  googleStatus: ServiceStatus;
  domainsStatus: ServiceStatus;
  antivirusStatus: ServiceStatus;
  webHostingStatus: ServiceStatus;
  dropboxStatus: ServiceStatus;
  adobeStatus: ServiceStatus;
  rmmStatus: ServiceStatus;
  m365BackupStatus: ServiceStatus;
  emailFilteringStatus: ServiceStatus;
}
